const Statuses = {
  "domain exists": {
    severity: "error",
    message: "آدرس دامنه تکراری است"
  },
  "toofast": {
    severity: "error",
    message: "آخرین پاکسازی کش کمتر از ۵ دقیقه قبل انجام شده است، لطفا برای پاکسازی مجدد کش صبر کنید."
  },
  "commit_success": {
    severity: "success",
    message: "اجرای تغییرات با موفقیت انجام شد!",
  },
  "commit_error": {
    severity: "error",
    message: "خطا در اجرای تغییرات!"
  },
  "report_error": {
    severity: "error",
    message: "خطا در دریافت اطلاعات!"
  },
  "general_error": {
    severity: "error",
    message: "خطا در دریافت اطلاعات!"
  },
  "edit_error": {
    severity: "error",
    message: "خطا در ویرایش اطلاعات!"
  },
  "success_user_domain": {
    severity: "success",
    message: "تخصیص دامنه‌ها به کاربر با موفقیت انجام شد!",
  },
  "error_user_domain": {
    severity: "error",
    message: "خطا در تخصیص دامنه‌ها به کاربر!",
  },
  "success_user_ip": {
    severity: "success",
    message: "تخصیص IPها به کاربر با موفقیت انجام شد!",
  },
  "error_user_ip": {
    severity: "error",
    message: "خطا در تخصیص IPها به کاربر!",
  },
  "error_param": {
    severity: "error",
    message: "خطا در تنظیم مقدار پارامتر!",
  },
  "success_param": {
    severity: "success",
    message: "مقدار پارامتر با موفقیت تنظیم شد!",
  },
  "logout_error": {
    severity: "error",
    message: "خطا در خروج از حساب کاربری!",
  },
  "copied": {
    severity: "info",
    message: "آدرس در کلیپ‌بورد کپی شد",
  },
  "dashboard_config_error": {
    severity: "error",
    message: "خطا در دریافت اطلاعات داشبورد",
  },
}
export default Statuses;